import Image from "next/image";
import { PropTypes } from "prop-types";

function StickyCartBtn({ onStickyCartClick, cartItemsCount }) {
  return (
    <div className="fixed top-[50%] right-[1rem] z-20 ">
      <button onClick={onStickyCartClick} className="bg-white rounded-full">
        <div className="indicator rounded-full h-[3.25rem] w-[3.25rem] bg-white hover:bg-[#E81E610D] active:bg-[#E81E610D] drop-shadow-[0_12px_38px_rgba(65,78,95,0.22)] border-[#EBEEF2] border-[1px] p-[.75rem]">
          {cartItemsCount !== 0 && (
            <span className="indicator-item text-[0.75rem] bg-darkPrimary w-[26px] h-[26px] text-white px-1 py-1 indicator-end rounded-full text-center">
              {cartItemsCount}
            </span>
          )}
          <div>
            <Image
              src="/assets/icons/cart-grey.svg"
              alt="banner top image"
              width={25}
              height={25}
            />
          </div>
        </div>
      </button>
    </div>
  );
}

export default StickyCartBtn;

StickyCartBtn.propTypes = {
  cartItemsCount: PropTypes.number,
  onStickyCartClick: PropTypes.func,
};
